module.exports = __webpack_public_path__ + "static/media/close.5ba281d0.svg";